<template>
  <div class="airline-dashboard-header-container" :style="customStyle">
    <img :src="image" alt="" v-if="image" />
    <div v-else class="no-image-found"></div>
    <div class="airline-dashboard-container-info">
        <h1>{{ name }}</h1>
        <div class="airline-dashboard-sub-info">
            <span>{{ subInfo.left }}</span>
            <div></div>
            <span>{{ subInfo.right }}</span>
        </div>
        <div class="airline-dashboard-action">
            <button class="secondary-btn" @click="$emit('show-documents')">Documents</button>
            <button class="secondary-btn" @click="$emit('show-notes')">Notes</button>
        </div>
    </div>
  </div>
</template>
<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        image: {
            type: String
        },
        subInfo: {
            type: Object,
            default: () => ({})
        },
        customStyle: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>
<style>
.airline-dashboard-header-container {
    /* padding: 0 40px; */
    display: flex;
    align-items: center;
    gap: 40px;
}
.airline-dashboard-header-container img,
.no-image-found {
    width: 150px;
    border-radius: 10px;
}
.no-image-found {
    background: #ccc;
    border-radius: 10px;
    height: 150px;
}
.airline-dashboard-container-info h1 {
    font-size: 60px;
    font-weight: bold;
    margin-top: -10px;
}
.airline-dashboard-container-info h1,
.airline-dashboard-container-info span {
    color: #404040;
}
.airline-dashboard-sub-info {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 0 8px;
}
.airline-dashboard-sub-info div {
    height: 23px;
    width: 2px;
    background: #9b9b9b;
}
.airline-dashboard-container-info span {
    font-size: 19px;
}
.airline-dashboard-action {
    display: flex;
    gap: 8px;
    margin-top: 10px;
    padding: 0 8px;
}
.secondary-btn {
    width: 160px;
    font-weight: normal;
    color: #fff;
    background-color: #9b9b9b;
    padding: 3px;
    border-radius: 5px;
}
</style>